module.exports = __webpack_public_path__ + "bc3c90bb.ttf";